import loggingService from '@/services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'dashboardService'
var path = '/Dashboard/'
var isDebug = false

function listDashboardResults (http) {
    loggingService.log(isDebug, serviceName, 'listDashboardResults')
    return http.get(path + 'ListDashboardResults').then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDateString(x.createdDate)
            })
        }
        return response
    }).catch(error => {
        throw error
    })
}

function listDashboardCoronerOthers (http) {
    loggingService.log(isDebug, serviceName, 'listDashboardCoronerOthers')
    return http.get(path + 'ListDashboardCoronerOthers').then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDateString(x.createdDate)
            })
        }
        return response
    }).catch(error => {
        throw error
    })
}

export default {
    listDashboardResults: listDashboardResults,
    listDashboardCoronerOthers: listDashboardCoronerOthers
}
